export default __webpack_public_path__ + "static/media/CRM-Main.206d3cc9.png";